import { GetProductResponse, Product, PRODUCT_MEDIA_TYPE, ProductMedias } from '@b2b/features/product/core/utilities/product.model';

function toUrlArray(value: string | string[] | undefined | null): string[] {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
}

export function normalizeProduct(products: GetProductResponse[]): Product[] {
  return products.map(product => {
    const displayName = product.name || product.sapName;

    const urls =
      toUrlArray(product.mediaUrls).length > 0 ? toUrlArray(product.mediaUrls) : toUrlArray(product.imageUrls);

    const medias: ProductMedias = {
      images: urls.map(url => ({
        [PRODUCT_MEDIA_TYPE.SUPER_ZOOM]: {
          src: url,
          altText: displayName,
        },
        [PRODUCT_MEDIA_TYPE.ZOOM]: {
          src: url,
          altText: displayName,
        },
        [PRODUCT_MEDIA_TYPE.PRODUCT]: {
          src: url,
          altText: displayName,
        },
        [PRODUCT_MEDIA_TYPE.THUMBNAIL]: {
          src: url,
          altText: displayName,
        },
        [PRODUCT_MEDIA_TYPE.CART_ICON]: {
          src: url,
          altText: displayName,
        },
        [PRODUCT_MEDIA_TYPE.ICON]: {
          src: url,
          altText: displayName,
        },
      })),
    };

    return {
      ...product,
      barcode: product.sapEAN,
      medias: medias,
    };
  });
}
